module.exports = __webpack_public_path__ + "media/images/msec_3-42db08cd5b4a8a6766aa977617a276c9.png";